<template>
  <table class="table table-sm table-hover mb-0">
    <thead class="t-head thead-light">
      <tr>
        <td v-translate>Data</td>
        <td v-translate>Availability</td>
        <td v-translate>Price</td>
        <td v-translate>Discount</td>
        <td></td>
      </tr>
    </thead>
    <tbody>
      <template v-for="(depDate, depDateIndex) in result.dates">
        <Date
          :depDate="depDate"
          :currency="result.currency"
          :key="'date' + depDateIndex"
          @selectDate="$emit('selectDate', $event)"
          @showPriceDetails="$emit('showPriceDetails', $event)" />
      </template>
    </tbody>
  </table>
</template>

<script>
import Date from './date.vue'
export default {
  props: {
    result: {
      type: Object,
      required: true
    }
  },
  components: {
    Date
  }
}
</script>
